import { DataAmigavel } from '@/shared/utils/datas';
import { ReadEstagiarioSelectDto, ResponseEstagioDto } from '@/api.types';
import { useDataTableStateStates } from '@/shared/components/tables/useDataTableState';

interface PerInternFiltersProps {
  estagiarioId?: number;
  setEstagiarioId: (id: number) => void;
  estagio?: ResponseEstagioDto;
  setEstagio: (estagio: ResponseEstagioDto | undefined) => void;
  estagiarios: ReadEstagiarioSelectDto[];
  estagios: ResponseEstagioDto[];
  tableState: useDataTableStateStates;
}

export function PerInternFilters({
  estagiarioId,
  setEstagiarioId,
  estagio,
  setEstagio,
  estagiarios,
  estagios,
  tableState
}: PerInternFiltersProps) {

  return (
    <div className="row mb-3">
      <div className="col-md-4">
        <label htmlFor="estagiario" className="col-form-label">
          Estagiário:{' '}
        </label>
        <select
          title="estagiario"
          className="form-select"
          id="estagiario"
          name="estagiario"
          value={estagiarioId}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const id = Number(e.target.value);
            tableState.setCurrentPage(1);
            setEstagiarioId(id);
          }}
        >
          {estagiarios !== undefined &&
            estagiarios !== null &&
            estagiarios.map((item) => (
              <option key={item.id} value={item.id}>
                {item.pessoa?.nome}
              </option>
            ))}
        </select>
      </div>

      <div className="col-md-4">
        <label htmlFor="estagio" className="col-form-label">
          Estágio:{' '}
        </label>
        <select
          title="estagio"
          className="form-select"
          id="estagio"
          name="estagio"
          value={estagio?.id}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const idEstagio = Number(e.target.value);
            tableState.setCurrentPage(1);
            setEstagio(estagios?.find((a) => a.id === idEstagio));
          }}
        >
          {estagios !== undefined &&
            estagios !== null &&
            estagios.map((item) => (
              <option key={item.id} value={item.id}>
                {''.concat(
                  item.curso?.nome || '',
                  ' - ',
                  DataAmigavel(item.data_inicio_estagio),
                  ' a ',
                  DataAmigavel(item.data_fim_estagio),
                )}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}

